<template>
  <div class="SpDivider">
    <div class="center" :class="classC" :style="style" />
  </div>
</template>

<script type="text/ecmascript-6">
import WHcomputed from '@/mixins/WHcomputed'
export default {
  name: 'SpDivider',

  nameSpace: 'SpDivider',

  components: {
  },

  mixins: [WHcomputed],

  props: {
    direction: {
      type: String,
      default: 'vertical'
    },

    width: {
      type: [Number, String],
      default: 1
    },

    height: {
      type: [Number, String],
      default: 1
    },

    type: {
      type: String,
      default: 'primary'// 颜色控制见setting
    },

    opacity: {
      type: [Number, String],
      default: 1
    },

    solid: Boolean
  },

  data () {
    return {
    }
  },

  computed: {
    classC () {
      const classes = []
      if (this.direction === 'vertical') {
        classes.push('divider')
        if (this.type === 'primary') {
          classes.push('divider-vtc' + (this.solid ? '-solid' : '') + '-1')
        }
        if (this.type === 'gray') {
          classes.push('divider-vtc' + (this.solid ? '-solid' : '') + '-7')
        }
      }
      if (this.direction === 'horizen') {
        classes.push('divider-hrz')
        if (this.type === 'primary') {
          classes.push('divider-hrz' + (this.solid ? '-solid' : '') + '-1')
        }
        if (this.type === 'gray') {
          classes.push('divider-hrz' + (this.solid ? '-solid' : '') + '-7')
        }
      }
      return classes
      // return [{ divider: this.direction === 'vertical', 'divider-hrz': this.direction === 'horizen' }, 'divider-' + this.type]
    },

    style () {
      const style = {}
      if (this.direction === 'vertical') {
        style.height = this.heightC
        style.opacity = this.opacity
      } else if (this.direction === 'horizen') {
        style.width = this.widthC
        style.opacity = this.opacity
      }
      return style
    }
  }
}
</script>

<style scoped lang="less">
.SpDivider{
  // width: 100%;
  // height: 100%;
  .center{
    margin:0 auto;
    width: 100%;
    height: 100%;
  }
  .divider{
    width: 0;
    // height:100%
  }
  .divider-hrz{
    height:0;
    // width: 100%;
  }
}
</style>
